import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
} from '@mui/material';
import TableOrderLayout from '../../components/user/TableOrderLayout';

const PrivacyPolicyPage = () => {
  return (
    // <TableOrderLayout 
    //   title="Terms and Conditions" 
    //   subtitle="Please read our terms and conditions carefully"
    //   showBackButton={true}
    //   showCart={false}
    // >
    <Container maxWidth="md" sx={{ py: { xs: 2, sm: 3, md: 4 }, mt: 18 }}>
      <Paper elevation={2} sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' } }}
        >
          Privacy Policy – Rangooli Foods Pte Ltd
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          gutterBottom
          sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
        >
          At Rangooli Foods Pte Ltd, we value your privacy and are committed to protecting your personal information.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ '& > *': { mb: { xs: 2, sm: 3 } } }}>
          {[
            {
              title: "1. Information We Collect",
              content: "We may collect basic information such as:",
              list: [
                "Name",
                "Phone number",
                "Email address",
                "Reservation or order details",
                "Feedback and enquiry details"
              ]
            },
            {
              title: "2. How We Use Your Information",
              content: "Your information is used only for:",
              list: [
                "Table reservations and order processing",
                "Customer support and communication",
                "Improving our services",
                "Sending updates or promotional offers (only when permitted)"
              ]
            },
            {
              title: "3. Data Protection",
              content:
                "We take reasonable measures to protect your personal information and do not sell or share your data with unauthorized third parties."
            },
            {
              title: "4. Third-Party Services",
              content:
                "Our website or online ordering platforms may use trusted third-party services for payments, reservations, or delivery support."
            },
            {
              title: "5. Cookies",
              content:
                "Our website may use cookies to improve user experience and website performance."
            },
            {
              title: "6. Your Rights",
              content: "You may contact us anytime to:",
              list: [
                "Access your personal information",
                "Correct inaccurate details",
                "Request deletion of your data"
              ]
            },
          ].map((section, index) => (
            <Box key={index}>
              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
              >
                {section.title}
              </Typography>
              <Typography
                variant="body2"
                paragraph
                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
              >
                {section.content}
              </Typography>
              {section.list && (
                <Typography
                  variant="body2"
                  component="ul"
                  sx={{
                    pl: { xs: 2, sm: 3 },
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }}
                >
                  {section.list.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </Typography>
              )}
              {section.additional && (
                <Typography
                  variant="body2"
                  paragraph
                  sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                >
                  {section.additional}
                </Typography>
              )}
            </Box>
          ))}

          {[].map((section, index) => (
            <Box key={index + 3}>
              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
              >
                {section.title}
              </Typography>
              <Typography
                variant="body2"
                paragraph
                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
              >
                {section.content}
              </Typography>
              {section.additional && (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: '0.875rem', sm: '1rem' },
                    whiteSpace: 'pre-line'
                  }}
                >
                  {section.additional}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      </Paper>
    </Container>
    // </TableOrderLayout>
  );
};

export default PrivacyPolicyPage;
